'use strict';

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

var _store = require('../store');

var _store2 = _interopRequireDefault(_store);

var _vuex = require('vuex');

var _themeCurrency = require('@shopify/theme-currency');

var currency = _interopRequireWildcard(_themeCurrency);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*----------------------------
Main - Vue Instance
---
Ensures any liquid template with a #main-vue id wrapper can have access to vuex store and methods.
----------------------------*/

if (document.querySelector('#main-vue')) {
  new _vue2.default({
    el: '#main-vue',
    delimiters: ['${', '}'],
    store: _store2.default,
    mounted: function mounted() {
      this.hydrateCartItems();
    },
    methods: Object.assign({}, (0, _vuex.mapActions)('cart', ['hydrateCartItems', 'removeCartItem', 'toggleMiniCart']), {
      formatMoney: function formatMoney(price) {
        return currency.formatMoney(price);
      },
      resizeShopifyImageUrl: function (_resizeShopifyImageUrl) {
        function resizeShopifyImageUrl(_x, _x2) {
          return _resizeShopifyImageUrl.apply(this, arguments);
        }

        resizeShopifyImageUrl.toString = function () {
          return _resizeShopifyImageUrl.toString();
        };

        return resizeShopifyImageUrl;
      }(function (url, size) {
        return resizeShopifyImageUrl(url, size);
      })
    }),
    computed: (0, _vuex.mapGetters)('cart', ['cartSubtotal', 'checkoutUrl'])
  });
}